import { useSalesContext } from "../../../sales-context/SalesContext";

export function useIsPacingActive(): boolean {
    const { features, partnerConfig } = useSalesContext();
    return Boolean(features.isPacingEnabled) && Boolean(partnerConfig.pacingTargets?.enabled);
}
